
import { Helmet } from "react-helmet";
import Products from "../../components/products/products";

export default function ViewAllTrendingPage() {
    return (
        <>
            <Helmet>
                <title>SHOP.CO | Trending Products - Popular Right Now</title>
                <meta
                    name="description"
                    content="Explore trending products at SHOP.CO. See what’s popular right now and shop items loved by our customers."
                />

                <link
                    rel="canonical"
                    href="https://shop-co-roan.vercel.app/view-all-trending/"
                />
            </Helmet>

            <Products endPoint="trending-products" pageType="trending" initialFilters={{ isTrending: true }} />
        </>
    )
}